import React from 'react';
import Marquee from "react-fast-marquee";
import Skill from './Skill';
import HtmlLogo from '../../Images/html5-logo.svg';
import CssLogo from '../../Images/css3-logo.svg';
import BootStrapLogo from '../../Images/bootstrap-logo.svg';
import JavaScriptLogo from '../../Images/javascript-logo.svg';
import ReactLogo from '../../Images/react-logo.svg';
import NextJsLogo from '../../Images/nextjs-logo-1.svg';
import ReduxLogo from '../../Images/redux-logo.svg';
import MaterialUi from '../../Images/material-ui-logo.svg';
import TailwindCssLogo from '../../Images/tailwind-css.svg';
import SassLogo from '../../Images/sass-logo.svg';
import FirebaseLogo from '../../Images/firebase-logo.svg';
import MongoDbLogo from '../../Images/mongodb-logo.svg';
import ExpressLogo from '../../Images/express-js-logo-1.svg';
import NodeJsLogo from '../../Images/nodejs-logo.svg';
import './Skills.css';

const Skills = () => {
    return (
        <section className='skills' id='skills'>
            <h1 className='title' data-aos="zoom-in">My Skills</h1>
            <Marquee 
                gradient={false}
                pauseOnHover={true}
                play={true}
                speed='99'
                className='skills_marquee'
            >
                <Skill title='HTML' Logo={HtmlLogo}/>
                <Skill title='CSS' Logo={CssLogo}/>
                <Skill title='BootStrap' Logo={BootStrapLogo}/>
                <Skill title='JavaScript' Logo={JavaScriptLogo}/>
                <Skill title='React' Logo={ReactLogo}/>
                <Skill title='NextJs' Logo={NextJsLogo}/>
                <Skill title='Redux' Logo={ReduxLogo}/>
                <Skill title='Material-Ui' Logo={MaterialUi}/>
                <Skill title='Tailwindcss' Logo={TailwindCssLogo}/>
                <Skill title='Sass' Logo={SassLogo}/>
                <Skill title='Firebase' Logo={FirebaseLogo}/>
                <Skill title='MongoDB' Logo={MongoDbLogo}/>
                <Skill title='Express' Logo={ExpressLogo}/>
                <Skill title='NodeJs' Logo={NodeJsLogo}/>
            </Marquee>
        </section>
    );
};

export default Skills;